import { APIClient } from '@/infrastructure/network/Legacy/APIClient'

export class LegacyGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
